// extracted by mini-css-extract-plugin
var _1 = "_projectManagementTable-module__button-container";
var _2 = "_projectManagementTable-module__danger";
export { _1 as "button-container", _2 as "danger" }
